{
  "Accessibility Menu": "Accessibility Menu",
  "Reset settings": "Astellungen zrécksetzen",
  "Close": "Zoumaachen",
  "Content Adjustments": "Inhalt Unpassungen",
  "Adjust Font Size": "Schrëftgréisst unpassen",
  "Highlight Title": "Titel markéieren",
  "Highlight Links": "Links markéieren",
  "Readable Font": "Liesbar Schrëft",
  "Color Adjustments": "Faarfleg Unpassungen",
  "Dark Contrast": "Däischteren Kontrast",
  "Light Contrast": "Hellen Kontrast",
  "High Contrast": "Héijen Kontrast",
  "High Saturation": "Héij Sättigung",
  "Low Saturation": "Niddrég Sättigung",
  "Monochrome": "Monochrom",
  "Contrast": "Kontrast",
  "Invert Colors": "Faarwen ëmklappen",
  "Tools": "Tools",
  "Reading Guide": "Guide fir ze liesen",
  "Stop Animations": "Animatiounen stoppen",
  "Big Cursor": "Groussen Cursor",
  "Increase Font Size": "Schrëftgréisst erhéijen",
  "Decrease Font Size": "Schrëftgréisst ernidderegen",
  "Letter Spacing": "Zeechenofstand",
  "Line Height": "Linn Héicht",
  "Font Weight": "Schrëftgewiicht",
  "Dyslexia Font": "Schrëft fir Dyslexie",
  "Language": "Sprooch",
  "Open Accessibility Menu": "Accessibility Menu opmaachen",
  "Widget Settings": "Widget-Astellungen",
  "Widget Position": "Widget-Positioun",
  "Top Left": "Uewen lénks",
  "Top Center": "Uewen am Zentrum",
  "Top Right": "Uewen riets",
  "Center Left": "Mëtt lénks",
  "Center Right": "Mëtt riets",
  "Bottom Left": "Ënnen lénks",
  "Bottom Center": "Ënnen am Zentrum",
  "Bottom Right": "Ënnen riets",
  "Screen Reader": "Ecran Lieser",
  "Voice Navigation": "Stëmmnavigatioun",
  "Custom Color": "Benotzerdefinéiert Faarf",
  "Change the site's colors": "Faarwe vum Site änneren",
  "Backgrounds": "Hannergrënn",
  "Headings": "Iwwerschrëften",
  "Contents": "Inhalter",
  "Reset colors": "Faarwen zerécksetzen",
  "Image Desaturation": "Bilddesaturatioun",
  "Search languages": "Sproochen sichen",
  "No languages found": "Keng Sproochen fonnt",
  "Accessibility Profiles": "Accessibilitéitsprofiler",
  "Motor Impaired": "Motorschen Handicap",
  "Big cursor, voice navigation, and no animations.": "Grousse Cursor, Stëmmnavigatioun an keng Animatiounen.",
  "Blind": "Blann",
  "Screen reader helpers with higher contrast.": "Screenreader-Hëllefen mat méi héijem Kontrast.",
  "Color Blind": "Faarweblann",
  "High contrast palette with desaturated media.": "Palette mat héijem Kontrast an ofgeblenkte Medien.",
  "Dyslexia": "Dyslexie",
  "Friendly font, extra spacing, stronger weight.": "Liicht liesbar Schrëft, méi Ofstand an déckere Schrëft.",
  "Low vision": "Schwaach Siicht",
  "Dark contrast and 130% magnification.": "Donkelen Kontrast an 130% Vergréisserung.",
  "Cognitive & Learning": "Kognitiv & Léieren",
  "Highlights key sections and enables voice help.": "Héicht wichteg Sektiounen eraus a schalt Stëmmhëllef fräi.",
  "Seizure & Epileptic": "Krampf & Epilepsie",
  "Stops animations and desaturates imagery.": "Stoppt Animatiounen a féiert manner Faarf bäi.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Liesguide, markéiert Linken a méi roueg Palette.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
